import React from 'react';
import * as ProfileInterface from '../../../../interfaces/profile.interface';
import * as DetailProfileInfoFC from '../../../../components/elements/profile/detail-each-profile-info';
import ProfileInfoTemplate from '../../../templates/ProfileInfoTemplate';

const ContactSection: React.FunctionComponent<ProfileInterface.IContactSectionProps> = ({
    roleView, social, contact, website, setModal
}) => {

    return (
    <>
        <ProfileInfoTemplate
            initData={social}
            DetailProfileInfoFC={
                DetailProfileInfoFC.SocialLinkComponent
            }
            roleView={roleView}
            modalName={ProfileInterface.UserSettingEnum.SocialLink}
            addButonContent={'Thêm một liên kết'}
            title={'Liên kết xã hội'}
            setModal={setModal}
        />
        <ProfileInfoTemplate
            initData={contact}
            DetailProfileInfoFC={
                DetailProfileInfoFC.ContactComponent
            }
            roleView={roleView}
            modalName={ProfileInterface.UserSettingEnum.Contact}
            addButonContent={'Thêm một thông tin liên hệ'}
            title={'Thông tin liên hệ'}
            setModal={setModal}
        />
        <ProfileInfoTemplate
            initData={website}
            DetailProfileInfoFC={
                DetailProfileInfoFC.WebsiteComponent
            }
            roleView={roleView}
            modalName={ProfileInterface.UserSettingEnum.Website}
            addButonContent={'Thêm một website'}
            title={'Website'}
            setModal={setModal}
        />
    </>
  );
};

export default ContactSection;
